module.exports = __webpack_public_path__ + "img/hot.3ccba60f.svg";